import React, { useEffect, useState } from 'react';
import { SmsFormTypeIds, SmsFormTypes } from '../../../Constantes/smsFormTypes';
import { EmailForm } from './EmailForm';
import SmsForm from './SmsForm';
import { useDispatch, useSelector } from 'react-redux';
import { selectTemplates, selectTemplateTypes } from '../../../redux/templates/selectors';
import { getTemplateTypes } from '../../../redux/templates/thunks';
import { PanelDialogue } from '../../common/PanelDialogue';
import SelectBox from "../../common/CustomSelectBox"
import { selectContract } from '../../../redux/contract/selectors';
import { selectWorkshopSearchFilters, selectWorkshopSearchLoading, selectWorkshopSearchResults } from '../../../redux/workshopSearch/selectors';
import { selectWorkshopTypes } from '../../../redux/workshopTypes/selectors';
import { selectCurrentCase } from '../../../redux/currentCase/selectors';
import { openModal } from '../../../redux/modal/modalSlice';
import dayjs from 'dayjs';
import { getCommentByCaseId, updateContractData } from '../../../redux/contract/thunks';
import { QUERY_GET_EMAIL_FROM_TEMPLATE, QUERY_POST_EMAIL, QUERY_POST_EMAIL_EXTERNAL } from '../../../fetch/constantQueries';
import { baseRequest } from '../../../fetch/basicThunk';
import { FormActionButtons } from '../../common/FormActionButtons';
import { useTranslation } from 'react-i18next';

export default function MessageForm (props) {
    const { t } = useTranslation();
    const [formType, setFormType] = useState(SmsFormTypes.default);
    const dispatch = useDispatch();
    const {setDisabledButtom, setshowMessageForm, setAllButtonsToState, disabledButtom, showMessageForm, phoneNumber} = props
    const contract = useSelector(selectContract);
    const workshopFilters = useSelector(selectWorkshopSearchFilters);
    const workshopTypes = useSelector(selectWorkshopTypes);
    const currentCase = useSelector(selectCurrentCase)
    const loadingWorkshopSearch = useSelector(selectWorkshopSearchLoading)
    const [dataForm,setDataForm] = useState({});
    const workshopSearch = useSelector(selectWorkshopSearchResults);
    const [replacedSms, setReplacedSms] = useState(null)
    const [updatePauPhone, setUpdatePauPhone] = useState()
    const templates = useSelector(selectTemplates)
    const formTypes = useSelector(selectTemplateTypes);
    const anchorEl = document.getElementById("message-button")

    const [dataEmailForm, setDataEmailForm] = useState({
        email: "",
        cc:"",
        urgent: false,
        plate: contract.plate != null ? contract.plate : "",
        number: "",
        name: "",
        surnames: "",
        workshopId: "",
        workshopType: workshopFilters?.searchOption || "",
        appointmentDate: null,
        subject: "",
        stationId: "",
        attachments: [],
      })

    const [smsTemplates, setSmsTemplates] = useState();
    const [internalEmailTemplates, setInternalEmailTemplates] = useState();
    const [externalEmailTemplates, setExternalEmailTemplates] = useState();

    useEffect(()=>{
        
      if(showMessageForm){
          dispatch(getTemplateTypes())
          setDataEmailForm(prevState => ({
            ...prevState,
            phoneNumber:currentCase != null && currentCase.phoneNumber != null ? currentCase.phoneNumber : contract.contractData == null ? contract.customerPhone == null ? "" : contract.customerPhone : contract.contractData.mobilePhone,
            plate: contract.plate != null ? contract.plate : "",
            name: contract.contractData?.userName || "",
            surnames : contract.contractData?.userSurnames || "",
            attachments: [],
          }));
      }
        
    },[showMessageForm])

    function handleTemplateChange (e) {
      let workshopType = "";
      if(workshopFilters?.searchOption){
        const {workshopTypeId} = workshopTypes.workshopTypes.find((w)=>w.workshopType === workshopFilters.searchOption);
        workshopType = workshopTypeId;
      }
    
        setDataEmailForm(prevState => (
          {...prevState,
              template: e,
              contentEmail: e?.text,
              subject: e?.templateTypeId === SmsFormTypeIds.external_email ? e?.subject ?? "" : "",
              workshopId: "",
              workshopType:  workshopType ?? "",
              appointmentDate: null,
              attachments: [],
          }
        ))
    }

    useEffect(()=>{
        if(Array.isArray(templates)){
            setSmsTemplates(templates.filter(template => template.templateTypeId === SmsFormTypeIds.sms))
            setInternalEmailTemplates(templates.filter(template => template.templateTypeId === SmsFormTypeIds.internal_email))
            setExternalEmailTemplates(templates.filter(template => template.templateTypeId === SmsFormTypeIds.external_email))
        }
    },[templates])


    function handleChangeSendEmailForm(field, value){
      setDataEmailForm(prevState=>({...prevState, [field]:value}))
    }

    useEffect(()=>{

        if(contract.contractData){
            setDataForm(prevState=>({
                ...prevState,
                name: contract.contractData?.userName? contract.contractData.userName : "",
                surname: contract.contractData?.userSurnames ?contract.contractData.userSurnames :"",
                email: contract.contractData?.email? contract.contractData.email : "",
                phoneNumber: contract.contractData?.mobilePhone?.trim() !== ""? contract.contractData?.mobilePhone : phoneNumber || ""
            }));
        }
    },[contract.contractData, phoneNumber])
    
    
    async function getEmailRecipientByTemplate(template){
      if(template){
        try {
              const recipientData = await baseRequest({query:`?templateCode=${template.templateCode}`}, dispatch, QUERY_GET_EMAIL_FROM_TEMPLATE, "POST")
    
              if(recipientData.value.length === 0 && template.templateTypeId !== SmsFormTypeIds.internal_email){
                setDataEmailForm(prevState=>({...prevState, email: contract?.contractData?.email? contract.contractData.email : "" }))
              }
              else {
                const resultToString = recipientData.value.filter(emailRecipient =>{return !emailRecipient.isCC;}).map(emailRecipient => emailRecipient.emailAddress).join("; ")
                const ccEmails = recipientData.value.filter(emailRecipient =>{return emailRecipient.isCC;}).map(emailRecipient => emailRecipient.emailAddress).join("; ")
                setDataEmailForm(prevState=>({...prevState, email: resultToString, cc: ccEmails}))
              }
              
        } catch (error) {
        }
      }
    }


    function handleChangeType(value){
        setFormType(value)
    }

    function handleSubmit(){   
        if (formType === SmsFormTypes.email || formType === SmsFormTypes.email_customer ) {
            handleSendEmailForm(formType === SmsFormTypes.email)
        }
    }

    //carga la lista de destinatarios del email en función de la taxonomía del caso
    useEffect(()=>{
    
        getEmailRecipientByTemplate(dataEmailForm.template)
     
    },[dataEmailForm.template, showMessageForm])

    useEffect(()=>{
      if(!showMessageForm){
        setDataEmailForm(prevState => ({
          ...prevState,
          template: null,
          subject: "",
          attachments: [],
        }))
      }
    },[showMessageForm])
    
    //Evento de envío de email
    async function handleSendEmailForm(internal) {
    
        const prevButtonsState = {...disabledButtom};
        setAllButtonsToState({disabled: true})
    
        const recipientsIntoArray = dataEmailForm.email? dataEmailForm.email.split(";") : []
        const ccEmailsIntoArray =  dataEmailForm.cc?.split(";") ?? [];
    
        const submitData = {
          addresses: recipientsIntoArray,
          ccAddresses: ccEmailsIntoArray, //dataEmailForm.template?.templateTypeId === SmsFormTypeIds.external_email ? [] :  ccEmailsIntoArray,
          templateId: dataEmailForm.template?.templateId,
          contentEmail: dataEmailForm.contentEmail,
          name: dataEmailForm.name,
          surnames: dataEmailForm.surnames,
          phone: dataEmailForm.phoneNumber,
          lastComment: SmsFormTypeIds.internal_email == dataEmailForm.template?.templateTypeId,
          subject: dataEmailForm.subject,
          caseId: currentCase.caseId,    
          number: null,
          email: internal ? "" : recipientsIntoArray.length > 0 ? recipientsIntoArray[0] : contract.contractData?.email ?? "",
          sendMail: true,
          plate: dataEmailForm.plate,
          model: contract.model && contract.model.length > 0 ? `${contract.brand} - ${contract.model}` : contract.brand,
          workshopId: dataEmailForm.workshopId,
          workshopType: (dataEmailForm.workshopType ?? "").toString(),
          appointmentDate: dataEmailForm.appointmentDate != null ? dayjs(dataEmailForm.appointmentDate).format("DD/MM/YYYY HH:mm") : "",
          stationId : (dataEmailForm.stationId ?? "").toString(),
          attachments: dataEmailForm.attachments,
        }
    
        if(!validateEmailForm(submitData, dataEmailForm.template)){
          setDisabledButtom(prevButtonsState);
          return
        }
    
        let url = QUERY_POST_EMAIL;
        if(dataEmailForm.template?.templateTypeId == SmsFormTypeIds.external_email) url = QUERY_POST_EMAIL_EXTERNAL;
    
         try {

            let submitFormData = new FormData();
            Object.keys(submitData).forEach(function (key) {
              if (key.toLowerCase() !== 'attachments') {
                submitFormData.append(key, submitData[key]);
              } else {
                if (submitData[key]) {
                  for (let attachment of submitData[key]) {
                    submitFormData.append('Attachments', attachment.file);
                  }
                }
              }
            });
            //await baseRequest({body: submitData}, dispatch, url, "POST")
            await baseRequest({ body: submitFormData, excludeContentType: true }, dispatch, url, 'POST');

            dispatch(openModal({ type: "success", message:"Email enviado."}));
            dispatch(getCommentByCaseId({query: `?caseId=${currentCase.caseId}`}));
            updatePauData(submitData);
            setshowMessageForm(false);
            setDataEmailForm(prevState => ({
              template:null,
              urgent: false,
              contentEmail: null,
              subject: "",
              workshopId: "",
              workshopType: "",
              appointmentDate: null,
              attachments: [],
            }))
    
         } catch (error) {
          
         } finally{
            setDisabledButtom(prevButtonsState);
        }
    }
    
    function validateEmailForm(emailForm, template){
    
      if(emailForm.addresses.length === 0){
        dispatch(openModal({type: "warning", message: "Debe adicionar algún destinatario"}));
        return false;
      }
      if(template.templateTypeId !== SmsFormTypeIds.internal_email && (!emailForm.subject || emailForm.subject.trim() === "")){
        dispatch(openModal({type: "warning", message: "Debe escribir el asunto"}));
        return false;
      }
      if(!emailForm.templateId){
        dispatch(openModal({type: "warning", message: "Debe seleccionar una plantilla"}));
        return false;
      }
      if(template.templateTypeId !== SmsFormTypeIds.external_email){
    
        if(!emailForm.contentEmail || emailForm.contentEmail.trim().length === 0){
          dispatch(openModal({ type: "warning", message: "El campo comentarios no puede estar vacío"}))
          return false;
        }
    
      }
      return true
    }
    
    async function updatePauData(dataDoct){
      const contractHasPauData = contract.contractData? true: false;
      const hasNewMobilePhone = contractHasPauData && dataDoct.number && dataDoct.number.trim() !== contract.contractData?.mobilePhone;
    
       if((!contractHasPauData || hasNewMobilePhone) && updatePauPhone){
    
         const submitData = {
          contractDataId: contract.contractData?.contractDataId,
          userName: contract.contractData?.userName,
          userSurnames: contract.contractData?.userSurnames,
          mobilePhone: hasNewMobilePhone || !contractHasPauData? dataDoct.number : contract.contractData?.mobilePhone,
          phone:contract.contractData?.phone,
          email: contract.contractData?.email,
          driversClub: contract.contractData?.driversClub,
          driversClubDate: contract.contractData?.driversClubDate? dayjs(contract.contractData?.driversClubDate,"DD/MM/YYYY").format("YYYY/MM/DD") : null,
          kilometrage: contract.contractData?.kilometrage,
          licenseNumber: contract.contractData?.licenseNumber
         }
    
         await dispatch(updateContractData({param: contract.id, body: submitData}))
        }
      }


  function handleChangeSendEmailForm(field, value){
    if(field.toLowerCase() == 'attachments'){
      const maxNameLength = 12;
      const filesArray = Array.from(value).map(file => ({
        file: file,
        name: file.name,
        nameMin: file.name.length > maxNameLength ? `${file.name.substring(0, maxNameLength)}...` : file.name,
        size: file.size ? `${(file.size / 1024 / 1024).toFixed(1)} MB` : '1.5 MB'
      }));
      setDataEmailForm(prevState=>({...prevState, [field]:filesArray}))
    }
    else
      setDataEmailForm(prevState=>({...prevState, [field]:value}))
  }

    return (
        <PanelDialogue
                    title={`${t("Send")} ${t("Message")}`}
                    open={showMessageForm}
                    anchorEl={anchorEl}
                    cancelFunction={() => props.handleShowForms(formType)}
                    showActionButtons={false}
        >
                <SelectBox label={t("Type")} labelMode='floating' value={formType} onValueChange={handleChangeType} placeholder="" dataSource={formTypes} displayExpr={"description"} valueExpr={"code"}></SelectBox>
                 {formType === SmsFormTypes.email &&
                     <EmailForm workshopSearch={workshopSearch}  handleChangeEmailForm={handleChangeSendEmailForm} handleTemplateChange={handleTemplateChange} dataForm={dataEmailForm} templates={internalEmailTemplates} formType={formType}/>
                 }
                 {formType === SmsFormTypes.email_customer &&
                     <EmailForm workshopSearch={workshopSearch}  handleChangeEmailForm={handleChangeSendEmailForm} handleTemplateChange={handleTemplateChange} dataForm={dataEmailForm} templates={externalEmailTemplates} formType={formType}/>
                 }
                 {(formType === SmsFormTypes.email_customer || formType === SmsFormTypes.email) &&
                    <div style={{paddingTop: "1rem", paddingBottom: "1rem"}}>
                      <FormActionButtons
                          cancelFunction={() => props.handleShowForms(formType)}
                          submitText={t("Send")}
                          cancelText={t("Cancel")}
                          handleTemplateChange={handleTemplateChange} 
                          disabledButtom={disabledButtom} 
                          submitFunction={()=>handleSendEmailForm(formType === SmsFormTypes.email)}
                      />
                    </div>
                 }
                 {formType === SmsFormTypes.sms  &&
                     <SmsForm 
                      // workshopSearch={workshopSearch} 
                      setReplacedSms={setReplacedSms} 
                      replacedSms={replacedSms}
                      phoneNumber={phoneNumber}
                      setAllButtonsToState={setAllButtonsToState}
                      disabledButtom={disabledButtom} 
                      cancelFunction={() => props.handleShowForms(formType)}
                      disableButtons={props.disabledSms}
                      setDisabledButtom={setDisabledButtom}
                      updatePauPhone={updatePauPhone}
                      setUpdatePauPhone={setUpdatePauPhone}
                      setshowMessageForm={setshowMessageForm}
                      // dataSms={dataSms} 
                      // handleChangeSendSMSForm={handleChangeSendSMSForm} 
                      handleTemplateChange={handleTemplateChange} 
                      templates={smsTemplates}
                      /> 
                 }{
                  !formType &&
                    <div style={{paddingTop: "1rem", paddingBottom: "1rem"}}>
                      <FormActionButtons
                          cancelFunction={() => props.handleShowForms(SmsFormTypes.default)}
                          submitText={t("Send")}
                          cancelText={t("Cancel")}                          
                          disableAccept={true}
                      />
                    </div>
                 }   
      </PanelDialogue>
    )



}


